export default "./images/survio-2Czcd-assets-date_answer.png";